import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutBottom: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="layout-bottom, margin, padding"><path d="M21 13.25C21 15.3211 19.3211 17 17.25 17H6.75C4.67893 17 3 15.3211 3 13.25V6.75C3 4.67893 4.67893 3 6.75 3H17.25C19.3211 3 21 4.67893 21 6.75V13.25Z" fill="currentColor"/><path d="M21 20.25C21 20.6642 20.6642 21 20.25 21H3.75C3.33579 21 3 20.6642 3 20.25C3 19.8358 3.33579 19.5 3.75 19.5H20.25C20.6642 19.5 21 19.8358 21 20.25Z" fill="currentColor"/></CentralIconBase>;
};

export default IconLayoutBottom;
